import * as React from 'react'
import { Box } from '@mui/material'
import { treeRoutes } from 'app/routing/routes'
import { useParams } from 'infrastructure/routing'
import { RouteLink } from 'app/components/RouteLink'

export function Index() {
  const { treeVersionNodeId } = useParams()
  return (
    <Box>
      <Box>
        {treeRoutes.map((r) => {
          const route = {
            ...r,
            path: r.path.replace(
              '/:treeVersionNodeId?',
              treeVersionNodeId ? `/${treeVersionNodeId}` : '',
            ),
          }
          return <RouteLink key={r.key} route={route} />
        })}
      </Box>
    </Box>
  )
}
